import {makeAutoObservable} from "mobx";
import {HistoryState} from "./historyState";
import {occupancyModel} from "./occupancy";
import {addResumeHandler} from "./resume";
import {OccupancyResponse} from "./types";

const initialHistoryState = {
	changeLockerOpen: false,
	openLockerOpen: false,
	helpOpen: false,
	addLocationOpen: false,
	enterLocationCodeOpen: false,
	currentOccupancyId: undefined as (number | undefined),
};

const historyState = new HistoryState(initialHistoryState);

class UiModel {
	constructor() {
		makeAutoObservable(this);
	}

	get changeLocker() {
		return historyState.current.changeLockerOpen;
	}

	get openLocker() {
		return historyState.current.openLockerOpen;
	}

	get help() {
		return historyState.current.helpOpen;
	}

	get addLocation() {
		return historyState.current.addLocationOpen;
	}

	get enterLocationCode() {
		return historyState.current.enterLocationCodeOpen;
	}

	get currentOccupancy() {
		return occupancyModel.getOccupancy(historyState.current.currentOccupancyId);
	}

	set currentOccupancy(occupancy: OccupancyResponse | undefined) {
		console.info("Setting current occupancy", occupancy);
		historyState.push({
			changeLockerOpen: false,
			currentOccupancyId: occupancy && occupancy.id,
		});
	}

	openHelp() {
		historyState.push({helpOpen: true});
	}

	openChangeLocker() {
		historyState.push({changeLockerOpen: true});
	}

	openOpenLocker() {
		historyState.push({openLockerOpen: true});
	}

	openAddLocation() {
		historyState.push({addLocationOpen: true});
	}

	openEnterLocationCode() {
		historyState.replace({addLocationOpen: false, enterLocationCodeOpen: true});
	}

	back() {
		console.debug("uiModel.back: Calling history.back");
		history.back();
	}

	home() {
		console.debug("uiModel.home: history length", history.length);
		historyState.replace(initialHistoryState);
	}
}

export const uiModel = new UiModel();

addResumeHandler(() => uiModel.home());
